var ArrayHelper = (function() {
	return {
		remove: remove
	};

	function remove(array, item) {
		var index;
		switch (typeof item) {
		case 'function':
			index = _.findIndex(array, item);
			break;

		default:
			index = array.indexOf(item);
			break;
		}

		if (index > -1) {
			array.splice(index, 1);
		}
	}
})();
